import React from 'react';

const Layout = ({ children }) => {
  return (
    <div className="main-content">
      <div className="content-area">
        {children}
      </div>
    </div>
  );
};

export default React.memo(Layout);
